import { linkLogicRelationships } from "cxa-utils";
import { findValidDependancyOptions } from "./riskmedicalDependancyOptionUtils";
import { isExist } from "cxa-utils";
// Construct configuration for per member based on eligible members
// get selectionMode for indication of per member
export const getPerMemberConfig = plan => {
  // TODO: Get the SelectedOption per member and apply the selection
  // For now, set to not selected
  const memberConfig = {
    isSelected: false,
    isAvailable: true,
    isReadOnly: false,
  };

  const { eligibleMembers, ...restPlan } = plan;

  if (eligibleMembers) {
    const members = [];

    if (Array.isArray(eligibleMembers)) {
      const [eligibleMember] = eligibleMembers;

      if (!Array.isArray(eligibleMember)) {
        const { member, ...restMember } = eligibleMember;

        members.push({
          ...restMember,
          ...member,
          ...memberConfig,
          selectable: member.selectable === "true",
        });
      }
      eligibleMembers.forEach(eligibleMember => {
        if (Array.isArray(eligibleMember)) {
          eligibleMember.forEach(eligible => {
            const { member, ...restMember } = eligible;
            const { type: memberType } = eligible;
            if (Array.isArray(member)) {
              members.push(
                ...member.map(imember => ({
                  ...imember,
                  ...memberConfig,
                  memberType: memberType,
                }))
              );
            } else {
              members.push({
                ...restMember,
                ...member,
                ...memberConfig,
                selectable: member.selectable === "true",
                memberType: memberType,
              });
            }
          });
        } else {
          const { member, ...restMember } = eligibleMember;
          const { type: memberType } = eligibleMember;
          if (Array.isArray(member)) {
            members.push(
              ...member.map(imember => ({
                ...imember,
                ...memberConfig,
                memberType: memberType,
              }))
            );
          } else {
            // Add one member
            members.push({
              ...restMember,
              ...member,
              ...memberConfig,
              selectable: member.selectable === "true",
              memberType: memberType,
            });
          }
        }
      });
    } else {
      const { member, ...restMember } = eligibleMembers;
      const { type: memberType } = eligibleMembers;
      members.push({
        ...restMember,
        ...member,
        ...memberConfig,
        selectable: member.selectable === "true",
        memberType: memberType,
      });
      if (Array.isArray(member)) {
        members.push(
          ...member.map(imember => ({ ...imember, memberType: memberType, ...memberConfig }))
        );
      } else {
        // Add one member
        members.push({
          ...restMember,
          ...member,
          ...memberConfig,
          selectable: member.selectable === "true",
          memberType: memberType,
        });
      }
    }

    const groupMembers = members.reduce((mArray, item) => {
      const existIndex = mArray.findIndex(m => m.key === item.key && m.type === item.type);
      if (existIndex >= 0) {
        mArray[existIndex].memberType = mArray[existIndex].memberType + "|" + item.memberType;
      } else {
        mArray.push(item);
      }
      return mArray;
    }, []);

    return {
      eligibleMembers: {
        members: groupMembers,
      },
      ...restPlan,
    };
  }
  return plan;
};

// Load saved member data
export const loadPerMemberSavedData = (
  lastSelectedPlan,
  selectedOption,
  defaultOption,
  eligibleMemberFilteredPlan,
  selectionMode,
  uiSelection
) => {
  if (selectionMode === "individual") {
    const {
      option: { id: selectedOptionPlanId, members: { member: selectedOptionMember } = {} } = {},
    } = selectedOption;
    const {
      option: { id: defaultOptionPlanId, members: { member: defaultOptionMember } = {} } = {},
    } = defaultOption;

    const userSelectedPlanId = selectedOptionPlanId !== "" ? selectedOptionPlanId : null;
    const selectedPlanId = uiSelection !== "Default" ? userSelectedPlanId : defaultOptionPlanId;

    const userSelectedOptionMember = isExist(selectedOptionMember) ? selectedOptionMember : {};
    const savedMember = uiSelection !== "Default" ? userSelectedOptionMember : defaultOptionMember;

    const {
      options,
      allIntervalOptions,
      eligibleMembers: { members = [] } = {},
      ...restPlan
    } = eligibleMemberFilteredPlan;

    const { maxEnroledMembers: _maxEnroledMembers = 0 } = members[0] || members;
    const maxEnroledMembers = parseInt(_maxEnroledMembers, 10);

    //TODO Backend better return lastApproved members with key
    const enrolledMembers = lastSelectedPlan.members
      ? [].concat(lastSelectedPlan.members).filter(m => m.isEnrolled === "true")
      : [];
    const savedMemberList = Array.isArray(savedMember)
      ? savedMember
      : [].concat({ ...savedMember });

    let isPlanIdFound = false;
    if (options) {
      isPlanIdFound = options.some(option => selectedPlanId === option.planId);
    } else if (allIntervalOptions) {
      const planIds = allIntervalOptions.map(aop => aop.optionId);
      isPlanIdFound = planIds.includes(selectedPlanId);
    }

    let applySavedMember;

    if (isPlanIdFound) {
      applySavedMember = members.map(member => {
        //for plan member checkbox, if plan has make selection then show as per selected member, else show last enrolled member
        const isSelected =
          savedMemberList.length >0 ?
          savedMemberList.some(savedMember => savedMember.key === member.key) :
          enrolledMembers.some(enrolledMember => enrolledMember.name === member.name);

        return {
          ...member,
          isSelected,
        };
      });
    } else {
      applySavedMember = members;
    }

    let selectedNum = applySavedMember.filter(
      member => member.isSelected && member.type !== "Employee"
    ).length;

    if (maxEnroledMembers >= 1 && selectedNum >= maxEnroledMembers) {
      applySavedMember.forEach(member => {
        if (member.type !== "Employee" && member.isSelected && member.selectable) {
          member.isLimit = "false";
        } else if (member.type !== "Employee" && member.selectable) {
          member.isLimit = "true";
        }
      });
    }

    return {
      ...restPlan,
      allIntervalOptions,
      options,
      eligibleMembers: {
        members: applySavedMember,
      },
    };
  }

  return eligibleMemberFilteredPlan;
};

export const applyBenefitChildrenMemberValidation = ({
  benefitID,
  parentBenefit,
  childBenefits,
  loadSavePlans: currentPlans,
  prevBenefits = [],
}) => {
  const { plans, selectionMode } = currentPlans;

  if (selectionMode === "individual") {
    if (!parentBenefit) {
      prevBenefits.push({
        benefitID,
        ...currentPlans,
      });
    }

    if (childBenefits.length === 0 && prevBenefits.length) {
      let selectedPlan = plans.find(plan => plan.isSelected) || {};

      if (selectedPlan) {
        prevBenefits.forEach(prevBenefit => {
          const { plans: prevPlans } = prevBenefit;
          const selectedPrevPlan = prevPlans.find(prevPlan => prevPlan.isSelected) || {};

          // Only apply per member validation on benefit children if there are parent benefits
          // Otherwise ignore
          if (parentBenefit !== null) {
            // apply which link logic to enable/disable per member selection on child benefit when loading saved data
            if (parentBenefit.linkLogicType === linkLogicRelationships.ByEqualPlanValue) {
              const { eligibleMembers: { members = null } = {}, ...restPlans } = selectedPlan;

              const memberList = members.map(member => {
                if (member.type !== "Employee") {
                  member.isReadOnly = true;
                }
                return member;
              });

              selectedPlan = {
                ...restPlans,
                eligibleMembers: { members: memberList },
              };
            }
            applyAvailableMember(selectedPlan, selectedPrevPlan, true);
          }
        });
      }
    }
  }
};

const SPOUSE = "Spouse";
const CHILDREN = "Children";
const EMPLOYEE = "Employee";

export const containChildrenOnly = member => member.type === CHILDREN;
export const containSpouseOnly = member => member.type === SPOUSE;
export const containFamily = memberTypeList =>
  [SPOUSE, CHILDREN].every(memberType => memberTypeList.includes(memberType));

export const containEmployeeSpouse = memberTypeList =>
  [EMPLOYEE, SPOUSE].every(memberType => memberTypeList.includes(memberType));

export const containEmployeeChildren = memberTypeList =>
  [EMPLOYEE, CHILDREN].every(memberType => memberTypeList.includes(memberType));

export const isChildrenOnly = memberTypeList =>
  !memberTypeList.map(member => member === CHILDREN).includes(false);

export const isSpouseOnly = memberTypeList =>
  !memberTypeList.map(member => member === SPOUSE).includes(false);

export const isDependentOnly = memberTypeList =>
  [EMPLOYEE].every(memberType => !memberTypeList.includes(memberType));

export const filterMemberTypeSelected = filterSelectedMembers =>
  filterSelectedMembers.map(member => {
    if (containSpouseOnly(member) || containChildrenOnly(member)) {
      return member.type;
    }

    return member.type;
  });

export const isMemberHasDependentMemberType = (memberList, memberType) =>
  memberList.some(member => member.memberType && member.memberType.includes(memberType));

export const getPlanByMemberSelection = ({ options, membersTemp: members, selectionMode }) => {
  if (selectionMode === "individual") {
    const selectedMember = members.filter(
      member => member.isSelected || member.type === "Employee"
    );
    const filterMemberTypes = filterMemberTypeSelected(selectedMember);
    const isSpouse = selectedMember.length > 0 ? containEmployeeSpouse(filterMemberTypes) : false;
    const isChildren =
      selectedMember.length > 0 ? containEmployeeChildren(filterMemberTypes) : false;
    const isCO = selectedMember.length > 0 ? isChildrenOnly(filterMemberTypes) : false;
    const isSO = selectedMember.length > 0 ? isSpouseOnly(filterMemberTypes) : false;
    const isDO = selectedMember.length > 0 ? isDependentOnly(filterMemberTypes) : false;
    const isFamily = isDO ? false : containFamily(filterMemberTypes);

    let memberType = "EE";

    if (isFamily) {
      memberType = "EF";
    } else if (isSpouse) {
      memberType = "ES";
    } else if (isChildren) {
      memberType = "EC";
    } else if (isCO) {
      memberType = "CO";
    } else if (isSO) {
      memberType = "SO";
    } else if (isDO) {
      memberType = "DO";
    }

    return options.map(option => {
      if (option.type === memberType) {
        option.isSelected = true;
      } else {
        option.isSelected = false;
      }
      return option;
    });
  } else {
    return options.map(option => {
      if (option.type === "EC" || option.type === "CO") {
        const selectedMember = members.filter(
          member => member.isSelected && member.type === CHILDREN
        );
        option.isSelected = selectedMember.length > 0;
      } else if (option.type === "ES" || option.type === "SO") {
        const selectedMember = members.filter(
          member => member.isSelected && member.type === SPOUSE
        );
        option.isSelected = selectedMember.length > 0;
      } else if (option.type === "EF" || option.type === "DO") {
        const selectedMember = members.filter(
          member => member.isSelected && member.type !== EMPLOYEE
        );
        const filteredMembers = filterMemberTypeSelected(selectedMember);

        option.isSelected = containFamily(filteredMembers);
      }
      // TODO: Add more type if needed e.g. CO, DO, Parent

      return option;
    });
  }
};

export const applyAvailableMemberForSinglePlan = (plans, parentPlan, isChildrenBenefit = false) => {
  const { eligibleMembers: { members = null } = {}, ...restPlans } = plans;
  const { eligibleMembers: { members: parentMembers = null } = {} } = parentPlan;
  if (members && parentMembers) {
    const membersTemp = members.map(member => {
      const selectedParentMember = parentMembers.filter(
        parentMember =>
          parentMember.isSelected &&
          member.key === parentMember.key &&
          member.name === parentMember.name
      );
      member.isAvailable = selectedParentMember.length > 0;
      member.isSelected = member.isAvailable ? member.isSelected : false;
    });
    return {
      eligibleMembers: { membersTemp },
      options: null,
      ...restPlans,
    };
  }
};
// Set available/selected plans into per member
// plans - contain the selected benefit children
// parentPlan - contain the selected benefit parent
export const applyAvailableMember = (plans, parentPlan, isChildrenBenefit = false) => {
  // check for per member
  const { eligibleMembers: { members = null } = {}, options, ...restPlans } = plans;

  const { eligibleMembers: { members: parentMembers = null } = {} } = parentPlan;

  if (members) {
    if (!options) {
      return applyAvailableMemberForSinglePlan(plans, parentPlan, isChildrenBenefit);
    }
    let planSelection = options;

    // get available plan after dependency options are applied
    const availablePlans = options.filter(
      option => option.isAvailable && (option.type !== "EE" && option.type !== "00")
    );

    const membersTemp = members.map(member => {
      if (
        member.type === CHILDREN &&
        availablePlans.find(plan => plan.type === "EC" || plan.type === "CO")
      ) {
        // get the list of selected member from parent product
        const selectedParentMember = parentMembers.filter(
          parentMember =>
            parentMember.type === CHILDREN &&
            parentMember.isSelected &&
            member.key === parentMember.key
        );

        member.isAvailable = selectedParentMember.length > 0;
        member.isSelected = member.isAvailable ? member.isSelected : false;
      } else if (
        member.type === SPOUSE &&
        availablePlans.find(plan => plan.type === "ES" || plan.type === "SO")
      ) {
        const selectedParentMember = parentMembers.filter(
          parentMember => parentMember.type === SPOUSE && parentMember.isSelected
        );

        member.isAvailable = selectedParentMember.length > 0;
        member.isSelected = member.isAvailable ? member.isSelected : false;
      } else if (availablePlans.find(plan => plan.type === "EF" || plan.type === "DO")) {
        const selectedParentMember = parentMembers.filter(
          parentMember => parentMember.isSelected && parentMember.type !== EMPLOYEE
        );

        member.isAvailable = isChildrenBenefit ? selectedParentMember.length > 1 : true;
      } else if (availablePlans.find(plan => plan.type === "CO" && plan.isSelected)) {
        // get the list of selected member from parent product
        const selectedParentMember = parentMembers.filter(
          parentMember =>
            parentMember.type === CHILDREN &&
            parentMember.isSelected &&
            member.key === parentMember.key
        );

        member.isAvailable = selectedParentMember.length > 0;
        member.isSelected = member.isAvailable ? member.isSelected : false;
      } else if (member.type !== EMPLOYEE) {
        member.isAvailable = false;
        member.isSelected = false;
      }

      // Disabled base on link logic
      // Refer to method applySamePlanValueToChildBenefitSelection below to set isReadOnly to true/false
      // e.g.
      // option 7, when plan value in parent benefit is selected, plan value in child benefits must be equal. Hence child benefit member must always be selected.
      if (member.isReadOnly) {
        member.isAvailable = !member.isReadOnly;
      }

      return member;
    });
    const { selectionMode: _selectionMode = "" } = (members && members[0]) || members;
    const selectionMode = _selectionMode.toLowerCase();
    planSelection = getPlanByMemberSelection({ options, membersTemp, selectionMode });

    return {
      eligibleMembers: { membersTemp },
      options: planSelection,
      ...restPlans,
    };
  }
};

export const applyPerMemberDependencySelection = (benefits, benefit, plan) => {
  /**
  need check parent's member selection to update the plan itself when this plan just selected
  **/
  if (benefit.parent) {
    blockPermMemberParentSelection(benefits, benefit, plan, benefit.parent.parentBenefitId);
    const selectedBenefit = benefits.find(
      item => item.benefitId === benefit.parent.parentBenefitId
    );
    if (
      selectedBenefit &&
      selectedBenefit.selectionMode &&
      selectedBenefit.selectionMode === "individual"
    ) {
      const selectedPlan = selectedBenefit.plans.find(item => item.isSelected);
      switch (benefit.parent.linkLogicType) {
        case linkLogicRelationships.ByEqualPlanValue:
          applyPerMemberDependencySelectionByEqualPlanValue(
            benefits,
            selectedBenefit,
            selectedPlan,
            benefit.benefitId
          );
          break;
        default:
          applyPerMemberDependencySelectionNotByEqualPlanValue(
            benefits,
            selectedBenefit,
            selectedPlan,
            benefit.benefitId
          );
          break;
      }
    }
  }
  if (Array.isArray(benefit.children)) {
    for (const childBenefit of benefit.children) {
      /**
      update child benefit only
      **/
      if (
        !childBenefit.isLinkedBenefitParentBenefit ||
        childBenefit.isLinkedBenefitParentBenefit === "false"
      ) {
        switch (childBenefit.linkLogicType) {
          case linkLogicRelationships.ByEqualPlanValue:
            applyPerMemberDependencySelectionByEqualPlanValue(
              benefits,
              benefit,
              plan,
              childBenefit.benefitId
            );
            break;
          default:
            applyPerMemberDependencySelectionNotByEqualPlanValue(
              benefits,
              benefit,
              plan,
              childBenefit.benefitId
            );
            break;
        }
      }
    }
  }
};

export const applyPerMemberDependencySelectionNotByEqualPlanValue = (
  benefits,
  selectedBenefit,
  selectedPlan,
  targetBenefitId
) => {
  const { eligibleMembers: { members = null } = {} } = selectedPlan || {};
  const targetBenefit = benefits.find(benefit => benefit.benefitId === targetBenefitId);
  if (members && targetBenefit && targetBenefit.selectionMode === "individual") {
    const dependancyOptions = findValidDependancyOptions(selectedPlan, targetBenefitId);
    let plans = [];
    if (!selectedPlan.options && !selectedPlan.intervalOptions) {
      plans = targetBenefit.plans.filter(
        plan =>
          plan.isAvailable &&
          plan.eligibleMembers &&
          plan.eligibleMembers.members &&
          dependancyOptions.some(option => option.dependancyBenefitID === targetBenefitId)
      );
    } else {
      plans = targetBenefit.plans.filter(
        plan =>
          plan.isAvailable &&
          plan.eligibleMembers &&
          plan.eligibleMembers.members &&
          dependancyOptions.some(option => option.optionID === plan.planId)
      );
    }
    if (plans) {
      plans.forEach(plan => {
        plan.eligibleMembers.members.forEach(member => {
          member.isAvailable = members.some(
            prevMember =>
              prevMember.key === member.key &&
              prevMember.name === member.name &&
              prevMember.isSelected
          );
          member.isSelected = member.isAvailable ? member.isSelected : false;
        });
        if (plan.intervalOptions) {
          const selectedMembers = plan.eligibleMembers.members.filter(m => m.isSelected);
          const selectedIntervalOption = plan.intervalOptions
            ? plan.intervalOptions.find(option => option.optionId === plan.planId)
            : null;
          let price = 0;
          if (selectedIntervalOption) {
            const memberPrice = []
              .concat(selectedIntervalOption.memberPrice)
              .filter(mp => selectedMembers.find(member => !!mp && member.key === mp.memberKey));
            memberPrice.forEach(mp => {
              price += parseFloat(mp.price.numericValue);
            });
          }
          plan.price = price;
        } else {
          const selectedMembers = plan.eligibleMembers.members.filter(
            m => m.isSelected || m.type === "Employee"
          );
          const addEmployeePrice = plan.planType ? plan.planType === "Group" : false;
          let price = 0;
          selectedMembers.forEach(memberObj => {
            if (plan.isRelativePrice) {
              price += parseFloat(memberObj.price.numericValue);
            } else if (addEmployeePrice) {
              price += parseFloat(memberObj.price.numericValue);
            } else if (!addEmployeePrice && memberObj.type && memberObj.type !== "Employee") {
              price += parseFloat(memberObj.price.numericValue);
            }
          });
          plan.price = price;
        }
      });
    }
  }
};

export const applyPerMemberDependencySelectionByEqualPlanValue = (
  benefits,
  selectedBenefit,
  selectedPlan,
  targetBenefitId
) => {
  const { eligibleMembers: { members = null } = {} } = selectedPlan || {};
  const targetBenefit = benefits.find(benefit => benefit.benefitId === targetBenefitId);
  if (members && targetBenefit && targetBenefit.selectionMode === "individual") {
    const dependancyOptions = findValidDependancyOptions(selectedPlan, targetBenefitId);
    let plans = [];
    if (!selectedPlan.options && !selectedPlan.intervalOptions) {
      plans = targetBenefit.plans.filter(
        plan =>
          plan.isAvailable &&
          plan.eligibleMembers &&
          plan.eligibleMembers.members &&
          dependancyOptions.some(option => option.dependancyBenefitID === targetBenefitId)
      );
    } else {
      plans = targetBenefit.plans.filter(
        plan =>
          plan.isAvailable &&
          plan.eligibleMembers &&
          plan.eligibleMembers.members &&
          dependancyOptions.some(option => option.optionID === plan.planId)
      );
    }
    if (plans) {
      plans.forEach(plan => {
        plan.eligibleMembers.members.forEach(member => {
          member.isAvailable = false;
          member.isSelected = members.some(
            prevMember =>
              prevMember.key === member.key &&
              prevMember.name === member.name &&
              prevMember.isSelected
          );
        });
        if (plan.intervalOptions) {
          const selectedMembers = plan.eligibleMembers.members.filter(m => m.isSelected);
          const selectedIntervalOption = plan.intervalOptions
            ? plan.intervalOptions.find(option => option.optionId === plan.planId)
            : null;
          let price = 0;
          if (selectedIntervalOption) {
            const memberPrice = []
              .concat(selectedIntervalOption.memberPrice)
              .filter(mp => selectedMembers.find(member => !!mp && member.key === mp.memberKey));
            memberPrice.forEach(mp => {
              price += parseFloat(mp.price.numericValue);
            });
          }
          plan.price = price;
        } else {
          const selectedMembers = plan.eligibleMembers.members.filter(
            m => (m.isSelected || m.type === "Employee") && m.price
          );
          const addEmployeePrice = plan.planType ? plan.planType === "Group" : false;
          let price = 0;
          selectedMembers.forEach(memberObj => {
            if (plan.isRelativePrice) {
              price += parseFloat(memberObj.price.numericValue);
            } else if (addEmployeePrice) {
              price += parseFloat(memberObj.price.numericValue);
            } else if (!addEmployeePrice && memberObj.type && memberObj.type !== "Employee") {
              price += parseFloat(memberObj.price.numericValue);
            }
          });
          plan.price = price;
        }
      });
    }
  }
};

/**
disable parent benefit permberm when child benefit permberm selected
**/
export const blockPermMemberParentSelection = (
  benefits,
  selectedBenefit,
  selectedPlan,
  targetBenefitId
) => {
  const { eligibleMembers: { members = null } = {} } = selectedPlan || {};
  const targetBenefit = benefits.find(benefit => benefit.benefitId === targetBenefitId);
  if (members && targetBenefit && targetBenefit.selectionMode === "individual") {
    const dependancyOptions = findValidDependancyOptions(selectedPlan, targetBenefitId);
    const isNoCoveragePlan = selectedPlan.groupValue === "0" && selectedPlan.planValue === "0";
    let onUpdatePlan;
    if (!selectedPlan.options && !selectedPlan.intervalOptions) {
      onUpdatePlan = targetBenefit.plans.find(
        plan =>
          plan.isAvailable &&
          plan.isSelected &&
          plan.eligibleMembers &&
          plan.eligibleMembers.members &&
          dependancyOptions.some(option => option.dependancyBenefitID === targetBenefitId)
      );
    } else {
      onUpdatePlan = targetBenefit.plans.find(
        plan =>
          plan.isAvailable &&
          plan.isSelected &&
          plan.eligibleMembers &&
          plan.eligibleMembers.members &&
          dependancyOptions.some(option => option.optionID === plan.planId)
      );
    }
    if (onUpdatePlan) {
      onUpdatePlan.eligibleMembers.members.forEach(member => {
        member.blockedByChild =
          !isNoCoveragePlan &&
          members.some(
            prevMember =>
              prevMember.key === member.key &&
              prevMember.name === member.name &&
              member.isSelected &&
              prevMember.isSelected
          );
      });
    }
  }
};

// Apply default member selection
export const applyDefaultMemberSelection = (plan, benefit) => {
  const {
    eligibleMembers: { members = [] } = {},
    defaultPlanMembers: { member: defaultMember = [] },
  } = plan;
  const defaultMembers = Array.isArray(defaultMember) ? defaultMember : [defaultMember];
  const { parent, lastSelectedPlan } = benefit;
  const enrolledMembers = lastSelectedPlan.members
    ? [].concat(lastSelectedPlan.members).filter(m => m.isEnrolled === "true")
    : [];
  const applyMemberSelection = members.map(member => ({
    ...member,
    isSelected:
      defaultMembers.some(
        defaultMember => defaultMember.key === member.key && defaultMember.type === member.type
      ) || enrolledMembers.some(enrolledMember => enrolledMember.name === member.name),

    isAvailable:
      parent &&
      parent.linkLogicType === linkLogicRelationships.ByEqualPlanValue &&
      member.type !== "Employee"
        ? false
        : member.isAvailable,
  }));

  return {
    members: applyMemberSelection,
  };
};

export const applySamePlanValueToChildBenefitSelection = ({
  selectedBenefit,
  selectedPlan: { eligibleMembers } = {},
  targetBenefit,
}) => {
  const { selectionMode } = selectedBenefit;

  if (selectionMode === "individual") {
    const { members: selectedMembers } = eligibleMembers;
    const { plans = [] } = targetBenefit;

    const selectedMemberList = selectedMembers.filter(
      selectedMember => selectedMember.isSelected && selectedMember.type !== "Employee"
    );

    targetBenefit.plans = plans.map(plan => {
      const {
        eligibleMembers: { members },
      } = plan;
      members.forEach(member => {
        member.isSelected = selectedMemberList.find(
          selectedMember => selectedMember.key === member.key && selectedMember.name === member.name
        )
          ? true
          : false;
        member.isReadOnly = true;
      });

      return plan;
    });
  }
};



// WEBPACK FOOTER //
// ./reducers/utils/riskmedicalPerMemberUtils.js